import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/rooms/[roomName]/PageClientImpl.tsx");
